<!-- eslint-disable vue/no-deprecated-v-on-native-modifier -->
<!--
 * @Description: 我的网盘
 * @Author: PF
 * @Date: 2024-06-06 14:43:34
 * @LastEditors: PF
 * @LastEditTime: 2024-06-13 17:06:23
-->
<template>
  <div class="list-page" @click="hidePanel">
    <el-container>
      <el-header>
        <!-- 按钮区域 BEGIN -->
        <div style="display: flex;align-items: center;justify-content: space-between;">
          <div class="button-box">
            <el-button type="primary" @click="openAdd=true"><span class="iconfont icon-chuangjian"></span>新建文件夹</el-button>
            <el-upload v-if="treeData.length && dqwz.id" :http-request="importClick" :auto-upload="true" :show-file-list="false" accept=""><el-button type="primary">上传文件</el-button></el-upload>
          </div>
          <div>
            <el-progress class="w200" stroke-width="10" :show-text="false" :percentage="setItemProgress(syqk.ysy, syqk.zkj)"></el-progress>
            <div style="display: flex;justify-content: space-between;"><span>{{syqk.ysy}}M/{{syqk.zkj}}M</span><el-text type="primary">剩余 {{syqk.zkj-syqk.ysy}}M</el-text></div>
          </div>
        </div>
        <!-- 按钮区域 END -->
        <!-- 搜索区域 BEGIN -->
        <div style="display: flex;align-items: center;justify-content: space-between;">
          <el-link :underline="false" @click="dqwz={};initList()">顶部</el-link>
          <div @submit.enter.prevent>
            <el-switch class="mr10" v-model="listTree" active-text="显示网盘" inactive-text="隐藏网盘" />
            <el-switch class="mr10" v-model="listFlag" active-text="列表模式" inactive-text="文件模式" />
            <el-input class="w200" placeholder="文件/文件夹名称" v-model="wjmc" clearable @clear="initList()" @keyup.enter="initList()">
              <template #suffix>
                <el-icon class="el-input__icon pointer" @click="initList()">
                  <search />
                </el-icon>
              </template>
            </el-input>
          </div>
        </div>
        <!-- 搜索区域 END -->
        <el-divider />
      </el-header>
      <el-container>
        <el-aside v-if="listTree===true" width="300px">
          <el-tree
            :data="treeData"
            :props="{children: 'children',label: 'value'}"
            ref="tree"
            node-key="label"
            default-expand-all
            style="max-width: 300px"
            @node-click="treeClick"
          >
            <template #default="{ node }">
              <span class="custom-tree-node">
                <span>{{ node.label }}</span>
              </span>
            </template>
          </el-tree>
        </el-aside>
        <el-main v-loading="loading">
          <div v-if="listFlag===false">
            <ul class="wenjian">
              <li v-for="(item,index) in tableData" :key="index" class="item" @click="wenJianClick(item)">
                <div class="el-upload" @contextmenu.prevent.native="openMenu($event, item, index)">
                  <div class="tubiao">
                    <el-image style="width: 100%; height: 100%" :src="'/wenjiantubiao/'+item.wjlxtbm+'.png'" fit="contain" >
                      <template #error>
                        <div class="image-slot">
                          <el-image style="width: 100%; height: 100%" :src="'/wenjiantubiao/moren.png'" fit="contain" />
                        </div>
                      </template>
                    </el-image>
                  </div>
                  <div class="beyond-hidden-single wp90">{{item.wjmc}}</div>
                </div>
              </li>
              <li v-if="treeData.length && dqwz.id">
                <el-upload :http-request="importClick" :auto-upload="true" :show-file-list="false" accept="">
                  <div class="tubiao"><span class="iconfont icon-chuangjian"></span></div>
                  <span>上传文件</span>
                </el-upload>
              </li>
            </ul>
          </div>
          <el-table v-if="listFlag===true" :data="tableData" height="100%" border stripe>
            <!-- 冻结列-Left BEGIN -->
            <el-table-column label="序号" type="index" width="80" fixed align="center" />
            <!-- 冻结列-Left END -->
            <el-table-column label="文件名称" prop="" header-align="center" align="left" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
              <template #default="scope">
                <span style="color: #409EFF;cursor: pointer;" v-if="scope.row.wjlx===2" @click="wenJianClick(scope.row)">{{scope.row.wjmc+'.'+scope.row.gs}}</span>
                <span style="color: #e6a23c;cursor: pointer;" v-if="scope.row.wjlx===1" @click="wenJianClick(scope.row)">{{scope.row.wjmc}}</span>
              </template>
            </el-table-column>
            <el-table-column label="文件类型" prop="bzrxm" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
              <template #default="scope">
                <el-text type="warning" v-if="scope.row.wjlx===1">文件夹</el-text>
                <el-text v-if="scope.row.wjlx===2">文件</el-text>
              </template>
            </el-table-column>
            <el-table-column label="文件大小" prop="wjdx" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
              <template #default="scope">
                {{scope.row.wjdx || 0}}M
              </template>
            </el-table-column>
            <el-table-column label="创建/上传人" prop="wjscrmc" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            <el-table-column label="创建/上传时间" prop="wjscsj" align="center" width="145" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            <!-- 冻结列-Right BEGIN -->
            <el-table-column label="操作" width="220" fixed="right" align="center">
              <template #default="scope">
                <el-button link type="primary" @click="openEdit=true; row=scope.row">重命名</el-button>
                <el-button link type="primary" @click="openYiDong=true; row=scope.row">移动</el-button>
                <el-button link type="primary" @click="xiaZaiClick(scope.row)">下载</el-button>
                <el-button link type="warning" @click="dataGrid.multipleSelection=[scope.row.id]; remove()">删除</el-button>
              </template>
            </el-table-column>
            <!-- 冻结列-Right END -->
          </el-table>
        </el-main>
      </el-container>
    </el-container>
  </div>
  <add v-if="openAdd" v-model:openAdd="openAdd" :row="{fwjid: dqwz.id, wplx: wplx}" @ReturnData="initTreeList();initKongJianShiYong()" />
  <edit v-if="openEdit" v-model:openEdit="openEdit" :row="row" @ReturnData="initTreeList()" />
  <deatil v-if="openDeatil" v-model:openDeatil="openDeatil" :row="row" />
  <yidong v-if="openYiDong" v-model:openYiDong="openYiDong" :row="row" @ReturnData="initTreeList()" />
  <fujian v-if="openFuJian" v-model:openDetail="openFuJian" :row="row" />
  <!-- 右键菜单 -->
  <ul id="myPanel" v-if="visible" :style="{ left: left + 'px', top: top + 'px' }" class="contextmenu">
    <li v-if="dqcd.wjlx===2" @click="openFuJian=true; visible=false; row={listFj:[{ fj: dqcd.wjlj+'/'+dqcd.wjmc+'.'+dqcd.gs}]}"><el-button link>预览</el-button></li>
    <li v-if="dqcd.wjlx===2" @click="openDeatil=true; visible=false; row=dqcd"><el-button link>详细信息</el-button></li>
    <li @click="openEdit=true; visible=false; row=dqcd"><el-button link>重命名</el-button></li>
    <li @click="openYiDong=true; visible=false; row=dqcd"><el-button link>移动</el-button></li>
    <li @click="xiaZaiClick(dqcd); visible=false"><el-button link>下载</el-button></li>
    <li @click="visible=false; wenJianRemove(dqcd)"><el-button link>删除</el-button></li>
  </ul>
</template>

<script setup>
import axios from 'axios'
import { ref } from 'vue'
import { loadSelect, actionPost, submitDataGridAction } from '@/api/common.js'
import { successPrompt, warningPrompt } from '@/utils/promptInfo.js'
import { download } from '@/utils/requestDownload.js'
import add from '@/pages/bangong/wangpanguanli/xuexiaowangpan/add.vue'
import edit from '@/pages/bangong/wangpanguanli/xuexiaowangpan/edit.vue'
import deatil from '@/pages/bangong/wangpanguanli/xuexiaowangpan/deatil.vue'
import yidong from '@/pages/bangong/wangpanguanli/xuexiaowangpan/yidong.vue'
import fujian from '@/components/fujian.vue'

const loading = ref(false)
const listTree = ref(true)
const listFlag = ref(false)
const wplx = ref(1) // 网盘类型:0-学校，1-个人网盘，2-部门网盘
const wjmc = ref()
const dqwz = ref({})

// 空间使用情况
const syqk = ref({ ysy: 0, zkj: 0 })
const initKongJianShiYong = () => {
  axios({
    url: process.env.VUE_APP_BASE_API + '/api/v2/bangong/wangpanguanli/wangpankongjianshezhi/countTeaPersonSpace',
    method: 'GET',
    headers: {
      accesscode: $cookies.get(process.env.VUE_APP_BASE_TOKEN)
    }
  }).then((res) => {
    if (res.data.code === 200) {
      syqk.value = res.data.data
    } else {
      warningPrompt(res.data.message)
    }
  })
}
initKongJianShiYong()
// 计算百分比
const setItemProgress = (ypsl, zsl) => {
  const progress = (ypsl / (zsl)) * 100
  progress.toFixed(1)
  return Number(progress)
}

const treeData = ref([])
const initTreeList = async () => {
  loadSelect({
    url: '/api/v2/bangong/wangpanguanli/wangpanwenjianguanli/wangpanwenjiantree',
    data: treeData,
    parms: {
      wplx: wplx.value
    },
    loadSuccess: function () {
      initList()
    }
  })
}
initTreeList()

// 点击树
const treeClick = (data) => {
  dqwz.value = {
    id: data.key,
    wjmc: data.value,
    wjlj: data.lj
  }
  initList()
}
// 列表
const tableData = ref([])
const initList = async () => {
  loading.value = true
  tableData.value = []
  loadSelect({
    url: '/api/v2/bangong/wangpanguanli/wangpanwenjianguanli/xuexiaowangpanwenjian',
    data: tableData,
    parms: {
      fwjid: dqwz.value.id || undefined,
      wjmc: wjmc.value,
      wplx: wplx.value
    },
    loadSuccess: function (res) {
      // 1-文件夹，2-文件
      res.data.map(item => {
        if (item.wjlx === 1) {
          item.wjlxtbm = 'wenjianjia'
        } else {
          item.wjlxtbm = item.gs
        }
        return item
      })
      loading.value = false
    }
  })
}

// 点击文件
const wenJianClick = (item) => {
  if (item.wjlx === 1) {
    dqwz.value = item
    initList()
  } else {
    row.value = { listFj: [{ fj: item.wjlj + '/' + item.wjmc + '.' + item.gs }] }
    openFuJian.value = true
  }
}

const row = ref()
const openAdd = ref(false)
const openEdit = ref(false)
const openYiDong = ref(false)
const openFuJian = ref(false)
const openDeatil = ref(false)

// 右键菜单 开始
const visible = ref(false)
const dqcd = ref({})
const dqcdind = ref()
const top = ref()
const left = ref()
const openMenu = (e, item, index) => {
  dqcd.value = item
  dqcdind.value = index
  const x = e.pageX // 这个应该是相对于整个浏览器页面的x坐标，左上角为坐标原点（0,0）
  const y = e.pageY // 这个应该是相对于整个浏览器页面的y坐标，左上角为坐标原点（0,0）
  top.value = y
  left.value = x
  visible.value = true // 显示菜单
}
// 点击区域外关闭右键菜单
const hidePanel = (event) => {
  const sp = document.getElementById('myPanel')
  if (sp) {
    if (!sp.contains(event.target)) { // 这句是说如果我们点击到了id为myPanel以外的区域
      visible.value = false // 关闭菜单
    }
  }
}
// 右键菜单 结束

// 资源文件上传
const importClick = async (file) => {
  const fileSuffix = file.file.name.substring(
    file.file.name.lastIndexOf('.') + 1
  )
  // 检测违规格式 开始
  const whiteList = ['exe', 'com', 'bat', 'scr']
  const isSuffix = whiteList.includes(fileSuffix.toLowerCase())
  if (isSuffix) {
    return warningPrompt('禁止上传 ' + whiteList + ' 格式文件')
  }
  // 检测违规格式 结束
  const formData = new FormData()
  formData.append('file', file.file)
  formData.append('dto', new Blob([JSON.stringify({ wjjlj: dqwz.value.wjlj, dto: { fwjid: dqwz.value.id, wplx: wplx.value } })], { type: 'application/json' }))
  axios({
    url: process.env.VUE_APP_BASE_API + '/api/v2/bangong/wangpanguanli/wangpanwenjianguanli/upload',
    data: formData,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data',
      accesscode: $cookies.get(process.env.VUE_APP_BASE_TOKEN)
    }
  }).then((res) => {
    if (res.data.code === 200) {
      successPrompt(res.data.message)
      initList()
      initKongJianShiYong()
    } else {
      warningPrompt(res.data.message)
    }
  })
}

// 下载
const xiaZaiClick = async (item) => {
  axios({
    url: process.env.VUE_APP_BASE_API + '/api/v2/bangong/wangpanguanli/wangpanwenjianguanli/download?diskFileId=' + item.id,
    method: 'GET',
    headers: {
      accesscode: $cookies.get(process.env.VUE_APP_BASE_TOKEN)
    }
  }).then((res) => {
    if (res.data.code === 200) {
      download(process.env.VUE_APP_BASE_API + res.data.message, item.wjmc)
    } else {
      warningPrompt(res.data.message)
    }
  })
}

// 右键删除
const wenJianRemove = async (item) => {
  const options = { url: '/api/v2/bangong/wangpanguanli/wangpanwenjianguanli/delentity/' + item.wplx + '/' + item.id, data: {} }
  actionPost(options).then((res) => {
    if (res.code === 200) {
      initTreeList()
      initKongJianShiYong()
      successPrompt(res.message)
    } else {
      warningPrompt(res.message)
    }
  })
}
// 列表删除
const dataGrid = ref({ multipleSelection: [] })
const remove = async () => {
  submitDataGridAction({
    url: '/api/v2/bangong/wangpanguanli/wangpanwenjianguanli',
    dataGrid: dataGrid.value,
    confirmTitle: '确定要删除吗?',
    method: 'delete',
    callback: function () {
      initTreeList()
      initKongJianShiYong()
    }
  })
}

</script>

<style lang="less" scoped>
@import '@/assets/css/wangpan.less';
</style>
